import React, { Component } from "react";

export default class BlinkButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      blinkOn: true
    };

    this.timer = null;
  }

  componentDidMount() {
    this.updateTimer();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.disable !== this.props.disable ||
        prevProps.interval !== this.props.interval) {
      this.updateTimer();
    }
  }

  componentWillUnmount() {
    this.stopTimer();
  }

  startTimer = () => {
    if (this.timer) {
      return;
    }

    this.timer = setInterval(() => {
      this.setState(prevState => ({
        blinkOn: !prevState.blinkOn
      }));
    }, this.props.interval || 500);
  };

  stopTimer = () => {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }

    this.setState({ blinkOn: true });
  };

  updateTimer = () => {
    if (this.props.disable) {
      this.stopTimer();
    } else {
      this.startTimer();
    }
  };

  handleClick = () => {
    if (this.props.disable) {
      return;
    }

    if (this.props.onClick) {
      this.props.onClick();
    }
  };

  render() {
    const {
      disable,
      imgDisabled,
      imgBlinkOn,
      imgBlinkOff,
      width,
      height
    } = this.props;

    let img;

    if (disable) {
      img = imgDisabled;
    } else {
      img = this.state.blinkOn ? imgBlinkOn : imgBlinkOff;
    }

    return (
      <button
        type="button"
        disabled={disable}
        onClick={this.handleClick}
        style={{
          width: width,
          height: height,
          padding: 0,
          border: "none",
          background: "transparent",
          cursor: disable ? "default" : "pointer"
        }}
      >
        <img
          src={img}
          alt=""
          width={width}
          height={height}
          draggable={false}
        />
      </button>
    );
  }
}